import { render, staticRenderFns } from "./CreateCarrousel.vue?vue&type=template&id=1a795439"
import script from "./CreateCarrousel.vue?vue&type=script&lang=js"
export * from "./CreateCarrousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports